<script>
export default {
  name: 'OapGenericDataProvider',
};
</script>

<script setup>
import { onMounted } from 'vue';

let element = null;

const props = defineProps({
  tag: { type: String, default: 'script' },
  type: { type: String, default: 'application/ld+json' },
  content: {
    type: Object,
    default: () => {},
  },
  parent: { type: String, default: 'head' },
});

onMounted(() => {
  element = document.createElement(props.tag);
  element.setAttribute('type', props.type);
  element.textContent = JSON.stringify(props.content);
  document[props.parent].appendChild(element);
});
</script>
